import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=5c2aea8b&lang=pug&"
import script from "./BalanceCard.vue?vue&type=script&lang=js&"
export * from "./BalanceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports